import React, { FC } from 'react';

import { Heading, Text } from '../../../../../components/common';
import { FormattedMessage } from 'react-intl';

import styles from './NewNoResultsInCategory.scss';

export const NewNoResultsInCategory: FC = () => (
  <div className={styles.topPart}>
    <div className={styles.texts}>
      <Heading size="medium">
        <FormattedMessage id="empty-state.category-no-results-title" />
      </Heading>
      <Text weight="thin" size="small" className={styles.subTitle} tagName="p">
        <FormattedMessage id="empty-state.category-no-results-subtitle" />
      </Text>
    </div>
  </div>
);
